import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Button, Result, Spin } from "antd";
import { GlobalUserMenu } from "../../components/GlobalUserMenu";
import { useUiState } from "../../state";
import { textMap } from "../../i18n";
import { fetchComplianceAccess } from "../../services/compliance";

export function StudioProGate() {
  const { lang } = useUiState();
  const t = textMap[lang];
  const navigate = useNavigate();
  const [canUseStudio, setCanUseStudio] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let mounted = true;
    fetchComplianceAccess().then((access) => {
      if (!mounted) return;
      setCanUseStudio(Boolean(access?.can_use_studio));
      setLoaded(true);
    });
    return () => {
      mounted = false;
    };
  }, []);

  if (!loaded) {
    return (
      <div
        className="studio-page studio-page-loading"
        style={{ position: "relative" }}
      >
        <div className="global-user-menu-corner">
          <GlobalUserMenu />
        </div>
        <Spin size="large" />
      </div>
    );
  }

  if (!canUseStudio) {
    return (
      <div className="studio-page" style={{ padding: 24, position: "relative" }}>
        <div className="global-user-menu-corner">
          <GlobalUserMenu />
        </div>
        <Result
          status="403"
          title={t.complianceHubLockedTitle}
          subTitle={t.complianceHubLockedLead}
          extra={
            <Button type="primary" onClick={() => navigate("/app/upgrade")}>
              {t.upgradePlanNow}
            </Button>
          }
        />
      </div>
    );
  }

  return <Outlet />;
}
